<template>
    <Header ueberschrift="Leistungsprüfung Wasser" />
    <div id="leistungspruefung-wasser">
        <div id="Geraet">
            <center>
                <h2 id="Geraetename">{{this.gegenstaende[0][0]}}</h2>
            </center>
        </div>
        <div id="Eingabe">
            <center>
                <div class="row">
                    <div class="col-3"></div>
                    <h3 class="col-6">
                        <div id="fahrzeugEingabe">
                            <label for="fahrzeuge">Fahrzeug:</label>
                            <select id="fahrzeuge" name="fahrzeuge" @change="fahrzeugChanged">
                                <option value="MLF">MLF</option>
                            </select>
                        </div>
                    </h3>
                    <div class="col-2">
                        <!--<button id="imageButton" onclick="showImage()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-card-image" viewBox="0 0 16 16">
                                <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                                <path
                                    d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13zm13 1a.5.5 0 0 1 .5.5v6l-3.775-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12v.54A.505.505 0 0 1 1 12.5v-9a.5.5 0 0 1 .5-.5h13z" />
                            </svg>
                        </button>-->
                    </div>
                    <div class="col-1"></div>
                </div>
                <div id="MLF">
                    <!--<span class="col-1"></span>-->
                    <span class="buttonsFahrzeugLinks col-3">
                        <button style="visibility: hidden;" class="buttonTop fahrzeugButton" @click="TLF('Da')">Da</button>
                        <button class="buttonTop mada buttonLinks fahrzeugButton" @click="MLF('Fa')">Fahrer</button>
                        <button class="buttonLinks fahrzeugButton" @click="MLF('G1')">G1</button>
                        <button class="buttonLinks fahrzeugButton" @click="MLF('G3')">G3</button>
                        <button class="buttonLinks fahrzeugButton" @click="MLF('He')">Heck</button>
                    </span>
                    <!--<span class="col-6 fahrzeugContainer">-->
                    <img class="Fahrzeug" src="@/assets/LeistungspruefungTHL/TLF.png">
                    <!--</span>-->
                    <span class="buttonsFahrzeugRechts col-3">
                        <button style="visibility: hidden;" class="buttonTop fahrzeugButton" @click="TLF('Da')">Da</button>
                        <button class="buttonTop mada buttonRechts fahrzeugButton" @click="MLF('Ma')">Ma</button>
                        <button class="buttonRechts fahrzeugButton" @click="MLF('G2')">G2</button>
                        <button class="buttonRechts fahrzeugButton" @click="MLF('G4')">G4</button>
                        <button class="buttonRechts fahrzeugButton" @click="MLF('Da')">Dach</button>
                    </span>
                    <!--<span class="col-1"></span>-->
                </div>
            </center>
        </div>
        <div class="Aufgabenzahl">
            <center>
                <h5 id="Aufgabe"></h5>
            </center>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { ref, onMounted } from 'vue'
import Swal from 'sweetalert2'

export default {
    name: 'MTA2',
    components: {
        Header,
        Footer
    },
    data() {
        return {
            gegenstaende: [["B-Strahlrohr", "MLF", "G3"],
            ["C-Strahlrohr", "MLF", "G3"],
            ["Druckbegrenzungsventil", "MLF", "He"],
            ["Feuerlöscher", "MLF", "G1"],
            ["Feuerwehrleine", "MLF", "Ma"],
            ["Handscheinwerfer", "MLF", "Ma"],
            ["Kübelspritze", "MLF", "G1"],
            ["Kupplungsschlüssel", "MLF", "He"],
            ["Mehrzweckleine", "MLF", "He"],
            ["Sammelstück", "MLF", "He"],
            ["Saugkorb", "MLF", "He"],
            ["Saugschutzkorb", "MLF", "He"],
            ["Schachthaken", "MLF", "G3"],
            ["Schlauchhalter", "MLF", "G4"],
            ["Standrohr", "MLF", "G3"],
            ["Stützkrümmer", "MLF", "G3"],
            ["Überflurhydrantenschlüssel", "MLF", "G3"],
            ["Unterflurhydrantenschlüssel", "MLF", "G3"],
            ["Übergangsstück A-B", "MLF", "He"],
            ["Übergangsstück B-C", "MLF", "G3"],
            ["Verteiler", "MLF", "G4"],
            ["Warndreieck", "MLF", "Ma"],
            ["Warn-/ Sicherungsleuchte", "MLF", "Ma"],
            ["Warnweste", "MLF", "Ma"],
            ["Verbandskasten", "MLF", "Ma"],
            ["Brechstange (haben nur Halligen-tool)", "MLF", "G3"],
            ["Reservekraftstoffkanister", "MLF", "G4"],
            ["Unterlegkeil", "MLF", "Fa"],
            ["Feuerwehraxt", "MLF", "G1"],
            ["Werkzeugkasten", "MLF", "G4"]],
            fehler: 0,
            index: 0,
        }
    },
    methods: {
        startGame: function () {
            this.index = 0;
            this.fehler = 0;
            this.gegenstaende = this.shuffle(this.gegenstaende);
            document.getElementById("Geraetename").innerHTML = this.gegenstaende[0][0];
            document.getElementById("Aufgabe").innerHTML = "Aufgabe: " + (+this.index + +1).toString() + "/" + this.gegenstaende.length.toString();
        },
        Next: function () {
            if (this.index < this.gegenstaende.length - 1) {
                this.index++;
                document.getElementById("Geraetename").innerHTML = this.gegenstaende[this.index][0];
                document.getElementById("Aufgabe").innerHTML = "Aufgabe: " + (+this.index + +1).toString() + "/" + this.gegenstaende.length.toString();
            } else {
                if (this.fehler == 0) {
                    Swal.fire({
                        title: 'Fehlerfrei',
                        text: 'Du hast alle ' + this.gegenstaende.length.toString() + ' richtig beantwortet.',
                        icon: 'success',
                        /*timerProgressBar: true,
                        timer: 4000,
                        didOpen: () => {
                            Swal.showLoading()
                            const b = Swal.getHtmlContainer().querySelector('b')
                            timerInterval = setInterval(() => {
                                b.textContent = Swal.getTimerLeft()
                            }, 100)
                        },
                        willClose: () => {
                            clearInterval(timerInterval)
                        }*/
                    }).then((result) => {
                        /* Read more about handling dismissals below */
                        if (result.dismiss === Swal.DismissReason.timer) {
                            console.log('I was closed by the timer')
                        }
                    })
                } else if (this.fehler <= 2) {
                    Swal.fire({
                        title: 'Naja',
                        text: 'Du hast ' + (+this.gegenstaende.length - +this.fehler).toString() + ' von ' + this.gegenstaende.length.toString() + ' richtig beantwortet.',
                        icon: 'warning',
                        /*timerProgressBar: true,
                        timer: 4000,
                        didOpen: () => {
                            Swal.showLoading()
                            const b = Swal.getHtmlContainer().querySelector('b')
                            timerInterval = setInterval(() => {
                                b.textContent = Swal.getTimerLeft()
                            }, 100)
                        },
                        willClose: () => {
                            clearInterval(timerInterval)
                        }*/
                    }).then((result) => {
                        /* Read more about handling dismissals below */
                        if (result.dismiss === Swal.DismissReason.timer) {
                            console.log('I was closed by the timer')
                        }
                    })
                } else if (this.fehler >= 3) {
                    Swal.fire({
                        title: 'Übungsbedarf',
                        text: 'Du hast nur ' + (+this.gegenstaende.length - +this.fehler).toString() + ' von ' + this.gegenstaende.length.toString() + ' richtig beantwortet.',
                        icon: 'error',
                        /*timerProgressBar: true,
                        timer: 4000,
                        didOpen: () => {
                            Swal.showLoading()
                            const b = Swal.getHtmlContainer().querySelector('b')
                            timerInterval = setInterval(() => {
                                b.textContent = Swal.getTimerLeft()
                            }, 100)
                        },
                        willClose: () => {
                            clearInterval(timerInterval)
                        }*/
                    }).then((result) => {
                        /* Read more about handling dismissals below */
                        if (result.dismiss === Swal.DismissReason.timer) {
                            console.log('I was closed by the timer')
                        }
                    })
                }
                this.startGame();
            }
        },

        fahrzeugChanged: function () {
            var fahrzeug = document.getElementById("fahrzeuge").options[document.getElementById("fahrzeuge").selectedIndex].text;

            if (fahrzeug == "MLF") {
                this.activateMLF();
            }
        },

        activateMLF: function () {
            document.getElementById("MLF").style.display = "flex";
        },

        deactivateMLF: function () {
            document.getElementById("MLF").style.display = "none";
        },

        MLF: function (Gate) {
            if (this.gegenstaende[this.index][2] == Gate) {
                    //alert("Richtig");
                    Swal.fire(
                        'Richtig',
                        '',
                        'success'
                    )
            } else {
                this.fehler++;
                //alert("Falsch! Das richtige Fach war auf dem MLF das Fach " + this.gegenstaende[this.index][2]);
                Swal.fire(
                    'Falsch!',
                    'Das richtige Fach war auf dem MLF das Fach ' + this.gegenstaende[this.index][2],
                    'error'
                )
            }
            this.Next();
        },

        shuffle: function (array) {
            let counter = array.length;

            // While there are elements in the array
            while (counter > 0) {
                // Pick a random index
                let index = Math.floor(Math.random() * counter);

                // Decrease counter by 1
                counter--;

                // And swap the last element with it
                let temp = array[counter];
                array[counter] = array[index];
                array[index] = temp;
            }

            return array;
        }
    },
    created() {
    },
    mounted() {
        document.onreadystatechange = () => {
            this.startGame();
        }
    }
}
</script>

<style lang="scss">
#leistungspruefung-wasser {
    display: block !important;
    position:absolute !important;
    height:auto !important;
    bottom:0 !important;
    top:0 !important;
    left:0 !important;
    right:0 !important;
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-top: 4.5rem;
    height: 72vh;
    overflow-y: scroll;
    background-color: white;

    .Ueberschrift {
        text-align: center;
    }

    #MLF {
        /* font-family:'Courier New', Courier, monospace !important; */
        display: flex;
        justify-content: center;
    }

    .buttonsFahrzeugLinks {
        height: 100%;
        padding-right: 0px !important;
    }

    .buttonsFahrzeugRechts {
        height: 100%;
        padding-left: 0px !important;
    }

    .buttonTop {
        margin-top: 1rem;
    }

    .fahrzeugButton {
        display: inline-block;
        /*width: 3.8rem;*/
        width: 95%;
        height: 3.8rem;
        margin-bottom: 0.15rem !important;
        font-size: 1.4rem !important;
    }

    .buttonRechts {
        border-right: 3px solid black;
        border-top: 3px solid black;
        border-bottom: 3px solid black;
        background-color: inherit;
        color: black;
        border-left: transparent;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        outline: none !important;


        border-left: 3px solid black;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }

    .buttonLinks {
        border-left: 3px solid black;
        border-top: 3px solid black;
        border-bottom: 3px solid black;
        background-color: inherit;
        color: black;
        border-right: transparent;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        outline: none !important;


        border-right: 3px solid black;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }

    .mada {
        margin-bottom: 2rem !important;
    }

    .Fahrzeug {
        /*height: auto;
    width: 100% !important;
    max-width:80% !important;*/
        height: 25rem;
        width: auto;
    }

    .fahrzeugContainer {
        padding: 0px !important;
    }
}
</style>